/**
 * Load vue-tippy on the client only. Making the plugin async keeps the
 * vue-tippy / tippy.js code out of the eager entry chunk; it is fetched as a
 * separate chunk once the app boots.
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  const [{ default: VueTippy }] = await Promise.all([
    import('vue-tippy'),
    // Load styles as a separate CSS chunk rather than inlining them into entry.css.
    import('tippy.js/dist/tippy.css')
  ]);

  nuxtApp.vueApp.use(VueTippy, {
    defaultProps: { placement: 'top' }
  });
});
